module.exports = __webpack_public_path__ + "static/media/rafi.0a6f7238.jpeg";